var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Go-to-Copy-2",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 L25,25 L0,25 L0,0 L25,0 Z M10.4797144,4 C9.91424106,4.00764786 9.22073243,4.50300281 9.20396567,5.13859452 C9.18874799,5.77418623 9.85481408,6.33661603 10.4202874,6.33661603 L10.4202874,6.33661603 L16.8175654,6.52714136 L9.3429538,14.001753 C8.88568207,14.4590247 8.88568207,15.1997745 9.3429538,15.6570462 C9.80022553,16.1143179 10.5409753,16.1143179 10.998247,15.6570462 L10.998247,15.6570462 L18.4728586,8.1824346 L18.663384,14.5797126 C18.6420402,15.2153043 19.2258138,15.818896 19.8614055,15.7960343 C20.5076886,15.7731688 20.9695139,15.0888025 21,14.5202856 L21,14.5202856 L20.7241191,5.41465102 C20.7164985,5.13573828 20.5686529,4.82784952 20.3796494,4.6220831 L20.3796494,4.6220831 C20.1584702,4.3993431 19.8962891,4.28502712 19.585349,4.27588091 L19.585349,4.27588091 Z",
    id: "Combined-Shape",
    transform: "translate(12.500000, 12.500000) scale(-1, 1) translate(-12.500000, -12.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LEFT-ARROW.b5f9acb14e5d193f8fecd3752f901a77.svg";
export { ForwardRef as ReactComponent };